export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "ID no disponible",
    nombre: item.nombre || "Nombre no disponible",
  }));
